/**
 * Referral program API types shared between API and UI.
 */
// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------
export class ReferralApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async getStats() {
        return this.client.get('/api/account/referral');
    }
    async createCode(params) {
        return this.client.post('/api/account/referral/codes', params ?? {});
    }
    async updateCode(codeId, params) {
        return this.client.patch(`/api/account/referral/codes/${encodeURIComponent(codeId)}`, params);
    }
    async deleteCode(codeId) {
        return this.client.delete(`/api/account/referral/codes/${encodeURIComponent(codeId)}`);
    }
    async redeem(params) {
        return this.client.post('/api/account/referral/redeem', params);
    }
    async getLanding(code) {
        return this.client.get(`/api/refer/${encodeURIComponent(code)}`);
    }
}
/** localStorage key for a referral code accepted on the landing page. */
export const PENDING_REFERRAL_CODE_STORAGE_KEY = 'adieuu:pending-referral-code';
/** Query param used to pass referral code through auth flow. */
export const REFERRAL_QUERY_PARAM = 'ref';
export function readPendingReferralCode() {
    if (typeof window === 'undefined')
        return null;
    try {
        const value = window.localStorage.getItem(PENDING_REFERRAL_CODE_STORAGE_KEY);
        return value?.trim() || null;
    }
    catch {
        return null;
    }
}
export function storePendingReferralCode(code) {
    if (typeof window === 'undefined')
        return;
    try {
        window.localStorage.setItem(PENDING_REFERRAL_CODE_STORAGE_KEY, code.trim().toLowerCase());
    }
    catch {
        // ignore storage failures
    }
}
export function clearPendingReferralCode() {
    if (typeof window === 'undefined')
        return;
    try {
        window.localStorage.removeItem(PENDING_REFERRAL_CODE_STORAGE_KEY);
    }
    catch {
        // ignore storage failures
    }
}
export function resolveReferralCodeFromLocation(search) {
    const params = new URLSearchParams(search);
    const ref = params.get(REFERRAL_QUERY_PARAM);
    return ref?.trim().toLowerCase() || null;
}
//# sourceMappingURL=referral-api.js.map